import { render, staticRenderFns } from "./SoftwareMago.vue?vue&type=template&id=c7a98a3e&"
import script from "./SoftwareMago.vue?vue&type=script&lang=ts&"
export * from "./SoftwareMago.vue?vue&type=script&lang=ts&"
import style0 from "./SoftwareMago.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7a98a3e')) {
      api.createRecord('c7a98a3e', component.options)
    } else {
      api.reload('c7a98a3e', component.options)
    }
    module.hot.accept("./SoftwareMago.vue?vue&type=template&id=c7a98a3e&", function () {
      api.rerender('c7a98a3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/SoftwareMago.vue"
export default component.exports